import { useQuery } from "@tanstack/react-query";

import { listStageTemplates } from "@/adapters/api";
import { toStageTemplate } from "../utils/map.ts";

export function useStageTemplates() {
	return useQuery({
		queryKey: ["stage-templates"],
		queryFn: async () => {
			const response = await listStageTemplates();
			return response.items.map(toStageTemplate);
		},
		staleTime: 30_000,
	});
}
